export enum DCTErrorType {
  UNSPECIFIED = 1,
  CONTACT_CS = 2,
  TIMEOUT = 3,
  CARD_SAVE = 4
}
